module.exports = __webpack_public_path__ + "static/media/crowns.1d612a75.png";